<button class="btn btn-sm btn-link"
        (click)="onReset()">Reset</button>